<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="fromDate"
                         v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
                         v-model="toDate"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Vendor</label>
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
              <Dropdown
                v-if="setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :disabled="true"
              />
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button label="Search" class="p-button-raised p-button-rounded" type="submit" lable="Search"
                      @click.prevent="searchDelivery"></Button>
            </div>

          </div>

          <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                   :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="col-md-12">
              <label for="reason" class="col-md-4 control-label">Reason</label>
              <div class="form-group col-md-8">
                <textarea class="form-control" rows="5" v-model="reason"></textarea>
              </div>
            </div>
            <template #footer>
              <Button class="btn btn-danger" type="submit" @click.prevent="updateOrderStatus">Send</Button>
              <Button class="btn btn-success" type="submit" @click.prevent="cancel">Cancel</Button>
            </template>
          </Dialogs>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.deliveredLists.length > 0">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>
            <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <DataTable :value="deliveredLists" dataKey="id" ref="dt" :selection.sync="selectedDeliveryId"
                       :paginator="true" editMode="cell" class="p-datatable-gridlines"
                       :rows="10" :filters="filters">
              <Column header="S.n" selectionMode="multiple" headerStyle="width: 3rem"></Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="deliveryDateNepali"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryDateNepali']"/>
                </template>
              </Column>
              <Column header="Del Code" :sortable="true" field="orderCode" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orderCode']"/>
                </template>
              </Column>
              <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-if="enableSettle" v-model="slotProps.data['customerName']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-if="enableSettle" v-model="slotProps.data['address']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Contact" :sortable="true" field="primaryContact" filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-if="enableSettle" v-model="slotProps.data['primaryContact']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['primaryContact']"/>
                </template>
              </Column>

              <Column header="Amount" bodyStyle="text-align: right" :sortable="true" field="billAmount"
                      filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-if="enableSettle" v-model="slotProps.data['billAmount']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billAmount']"/>
                </template>
              </Column>
              <Column header="Payable Amt" bodyStyle="text-align: right" :sortable="true" field="payableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['payableAmount']"/>
                </template>
              </Column>
              <Column header="Del Charge" bodyStyle="text-align: right" :sortable="true" field="deliveryChargeAmount"
                      filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-if="enableSettle" v-model="slotProps.data['deliveryChargeAmount']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryChargeAmount']"/>
                </template>
              </Column>

              <Column header="Status" bodyStyle="text-align: right" :sortable="true" field="orderStatus"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orderStatus']"/>
                </template>
              </Column>

              <Column header="Delivered By" bodyStyle="text-align: right" :sortable="true" field="assignToName"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['assignToName']"/>
                </template>
              </Column>

              <Column header="Store" bodyStyle="text-align: right" :sortable="true" field="storeName"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['storeName']"/>
                </template>
              </Column>

              <Column header="Remarks" bodyStyle="text-align: right" :sortable="true" field="remarks"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['remarks']"/>
                </template>
              </Column>

            </DataTable>
          </div>
            </div>
            <div class="p-grid p-col-12 p-md-3 p-mt-2">
              <Button v-if="enableSettle" class="p-button-raised p-button-success"
                      label="Returned To Vendor"
                      @click.prevent="updatePaidStatus()"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'

export default {
  name: 'deliveredReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      deliveredLists: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      idsForDelivery: [],
      selectedDeliveryId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      paymentStatusData: '',
      inventoryHeaderId: null,
      enableSettle: false,
      assignedTo: null,
      setWarehouseData: false,
      warehouseId: null
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
    }
  },
  mounted() {
    this.warehouseList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableSettle()
    this.setWarehouse()
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  methods: {
    async searchDelivery() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        warehouse: this.id
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadCancelledDeliveryDetailsLists', dat)
      let users = await this.$store.dispatch('loadUser')
      this.loading = false
      this.userList = users.data.data
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.deliveredLists = []
      } else {
        this.deliveredLists = resp.data.data
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    showReasonDialog(data) {
      this.inventoryHeaderId = data.id
      this.ecommerceStatusData = data.orderStatus
      this.paymentStatusData = data.paymentStatus
      if (data.orderStatus === 'Hold' || data.orderStatus === 'Cancelled') {
        this.ecommerceStatusDialog = true
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.orderStatus
        this.paymentStatusData = data.paymentStatus
      }
      if (data.orderStatus === 'Completed') {
        this.reason = '-'
        this.updateOrderStatus()
      }
    },
    async updateAssignedToUser(data) {
      // if (data.assignedTo === undefined) {
      //   this.assignedToId = 0
      // } else {
      //   this.assignedToId = data.assignedTo.id
      // }
      // if (this.assignedToId === undefined) {
      //   this.assignedToId = data.assignedTo.id
      // }
      let userData = {
        inventoryHeaderId: data.id,
        statusType: data.orderStatus,
        reason: data.remarks,
        assignedTo: data.assignedTo,
        paymentStatus: data.paymentStatus,
        deliveryCharge: data.deliveryChargeAmount,
        billAmount: data.billAmount,
        paymentMethod: data.paymentMethod,
        customerName: data.customerName,
        address: data.address,
        primaryContact: data.primaryContact
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.ecommerceStatusDialog = false
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportForRequest/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/CompletedReport' + '/' + this.$store.getters.fyId + '/' + this.$store.getters.warehouseId.id + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'completedReport.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    checkEnableSettle() {
      if (this.$store.getters.modules.includes(',6.11')) {
        this.enableSettle = true
      }
    },
    expexportToPdfOrderortToPdf() {
      if (this.selectedDeliveryId !== null) {
        this.selectedDeliveryId.forEach(salesOrderId => this.idsForDelivery.push(salesOrderId.id))
      }
      if (this.idsForDelivery.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one order!', life: 10000})
        return
      }
      if (this.idsForDelivery.length > 5) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry Cannot more then 5 order!', life: 10000})
        return
      }
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
          this.$store.getters.userId + '/' + this.idsForDelivery,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No' + this.idsForDelivery + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idsForDelivery = []
      this.selectedDeliveryId = null
    },
    columnNames() {
      for (let i = 0; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    editSalesOrder(data) {
      this.$router.push({name: 'Sales Order', params: {salesOrder: data}})
    },
    selectedSalesOrder(data) {
      // this.selectedSalesOrderId.push(data.id)
      if (!this.idsForDelivery.includes(data)) {
        this.idsForDelivery.push(data)
      }
    },
    async updatePaidStatus() {
      if (this.selectedDeliveryId !== null) {
        this.selectedDeliveryId.forEach(deliveryOrderId => this.idsForDelivery.push(deliveryOrderId.id))
      }
      if (this.idsForDelivery.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one delivery!', life: 10000})
        return
      }
      let userData = {
        idsForDelivery: this.idsForDelivery
      }
      let resp = await this.$store.dispatch('updateReturnedToVendor', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.idsForDelivery = ''
        this.selectedDeliveryId = ''
        // this.ecommerceStatusDialog = false
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesOrder', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.deliveredLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    InputMask,
    Dropdown,
    Dialogs,
    Checkbox,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// deliveryCancelledReport.vue?0701c383